export default {
	vipBenefits: {
		salaryTitle: 'VIP Sahod',
		benefitsTitle: 'Mga Benepisyo',
		yourVipProgress: 'Iyong VIP Progress',
		progressToVip: '{percent}% hanggang VIP {level}',
		vipMax: 'Naabot na ang Pinakamataas na Antas',
		vipLevelBenefits: 'VIP Antas at Benepisyo',
		betXpRule: 'Taya {amount} = {xp}EXP',
		btnReceive: 'Kunin',
		btnJoinIn: 'Sumali',
		btnReceived: 'Nakuha na',
		btnExpired: 'Nag-expire na',
		btnNotSettled: 'Hindi pa Settled',
		btnComingSoon: 'Malapit na',
		btnViewMore: 'Tingnan pa',
		btnContactNow: 'Makipag-ugnayan',
		guestTitleLevelup: 'Bonus sa Pag-level Up',
		guestTitleDaily: 'Araw-araw na Sahod',
		guestTitleWeekly: 'Lingguhang Sahod',
		guestTitleMonthly: 'Buwanang Sahod',
		guestTitleCashback: 'Cashback',
		guestTitleRescue: 'Bonus na Pantulong',
		guestTitleEvents: 'Mga Event ng VIP',
		guestTitleSupport: 'Suporta sa VIP',
		guestDescLevelup: 'Kumuha ng one-time bonus sa tuwing aabot ka sa bagong VIP level.',
		guestDescDaily: 'Mag-claim ng araw-araw na gantimpala ng sahod habang tumataas ang iyong VIP level.',
		guestDescWeekly: 'Mag-claim ng lingguhang gantimpala ng sahod habang tumataas ang iyong VIP level.',
		guestDescMonthly: 'Mag-claim ng buwanang gantimpala ng sahod habang tumataas ang iyong VIP level.',
		guestDescCashback: 'Kumita ng cashback sa iyong paggastos sa laro.',
		guestDescRescue: 'Kumuha ng bonus na pantulong upang makabangon ka muli.',
		guestDescEvents: 'Ang mas mataas na VIP level ay nagbubukas ng mas maraming eksklusibong gantimpala ng event.',
		guestDescSupport: 'Nakatuong suporta sa VIP para sa mas mabilis na tulong.',
		comingSoonHint: 'Malapit nang dumating ang benepisyo, abangan',
		receiveSuccess: 'Nakuha ang reward',
		receiveFailed: 'Hindi nakuha ang reward',
		typeUpgrade: 'Bonus sa Pag-level Up',
		typeDailySalary: 'Araw-araw na Sahod',
		typeWeeklySalary: 'Lingguhang Sahod',
		typeMonthlySalary: 'Buwanang Sahod',
		typeRebate: 'Cashback',
		typeRescue: 'Bonus na Pantulong',
		typeVipActivity: 'Mga Event ng VIP',
		typeVipService: 'Suporta sa VIP',
		tooltipRecharge: 'Recharge {current}/{target}',
		tooltipBets: 'Taya {current}/{target}',
		progressRecharge: 'Recharge',
		progressBets: 'Taya',
		descUpgradeBonus: 'VIP{level} Upgrade Bonus ×{count}',
		descDailySalary: 'VIP{level} Araw-araw na Sahod ×{count}',
		descWeeklySalary: 'VIP{level} Lingguhang Sahod ×{count}',
		descMonthlySalary: 'VIP{level} Buwanang Sahod ×{count}',
		descUpgradeBonusPlain: 'VIP{level} Upgrade Bonus',
		descDailySalaryPlain: 'VIP{level} Araw-araw na Sahod',
		descWeeklySalaryPlain: 'VIP{level} Lingguhang Sahod',
		descMonthlySalaryPlain: 'VIP{level} Buwanang Sahod',
		descRebate: 'VIP{level} Game Cashback',
		descRescue: 'VIP{level} Bonus na Pantulong',
		descVipActivity: 'Ang mas mataas na VIP level ay nagbubukas ng mas maraming eksklusibong gantimpala ng event.',
		descVipService: 'Nakatuong suporta sa VIP para sa mas mabilis na tulong.',
		allBenefits: 'Lahat ng Benepisyo',
		vipClubTitle: 'VIP Club',
		more: 'Higit pa',
		moreDesc: 'Tingnan ang aming mga promosyon para sa higit pang detalye.',
		promotions: 'Mga Promosyon',
		highlightsTitle: '8 Tampok na Highlight',
		highlightSupport: 'Eksklusibong VIP Support',
		highlightLevelup: 'Level Up Bonus',
		highlightSalary: 'VIP Sahod',
		highlightRescue: 'VIP Rescue Bonus',
		highlightGifts: 'Eksklusibong\nVIP Gifts',
		highlightEvents: 'VIP Events',
		highlightService: 'Dedikadong\nVIP Service',
		highlightWallet: 'VIP\nCredit Wallet',
		currentLevel: 'Kasalukuyang Antas',
		keepPlayingReach: 'Magpatuloy sa paglalaro para maabot',
		higherLevelRewards: 'Mas mataas na antas, mas malaking gantimpala',
		levelUpUnlock: 'Mag-level up para i-unlock ang mga eksklusibong benepisyo at tamasahin ang premium na karanasan.',
		yourVipBenefits: 'Iyong VIP Benefits',
		viewVipLevels: 'Tingnan ang VIP Levels',
		exclusiveBenefitsTitle: 'Iyong Eksklusibong Benepisyo',
		tipExclusiveRewards: 'Eksklusibong Rewards',
		tipHigherRakeback: 'Mas Mataas na Rakeback',
		tipPrioritySupport: 'Priority Support',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: 'Antas',
		tableRequiredXp: 'Kailangang EXP',
		tableLevelUpBonus: 'Bonus sa pag-level up',
		tableDailyRakeback: 'Pang-araw-araw na rakeback',
		tableWeeklyLossback: 'Lingguhang lossback',
		signIn: 'Mag-sign in',
		vipClubDefaultDesc: 'Sumali na sa aming VIP Club at maghanda para sa mga regalo, giveaway, at kamangha-manghang features.',
	},
};
